import { Button, QRCode } from 'antd'
import React, { useRef } from 'react'
import AppleIcon from '../assets/icons/Apple'
import AndroidIcon from '../assets/icons/Android'
import WindowIcon from '../assets/icons/Window'
import { BASE_URL } from '../constants/Url'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import AppQRDownloadModal from './AppQRDownloadModal'
import AppStoreDownloadModal from './AppStoreDownloadModal'
import AndroidDownloadModal from './AndroidDownloadModal'
import { APP_ANDROID_APK_URL, APP_IOS_URL } from '../config/api'
import i18n from '../i18n/config'

export default function DownloadApp(props) {
    const { containerRef, className, title } = props;
    const { t } = useTranslation();
    const appQRDownloadModalRef = useRef(null);
    const appStoreDownloadModalRef = useRef(null);
    const androidDownloadModalRef = useRef(null);
    const navigate = useNavigate();
    const currentLang = i18n.language;
    const validLang = ['en'].includes(currentLang);

    const openQrDownload = () => {
        appQRDownloadModalRef?.current?.showModal();
    }

    function downloadApk() {
        androidDownloadModalRef?.current?.showModal();
    }

    function downloadIos() {
        appStoreDownloadModalRef?.current?.showModal();
    }

    return (
        <div className={'select-none relative ' + className} ref={containerRef}>
            <img className='esi-download-background-image' src={BASE_URL + "/download-background/AppBackground.png"} />
            <div className='gap-[20px] p-[1.25rem] md:p-[4rem] h-full relative z-[1] flex flex-col justify-between' >
                {title}
                <div className='flex gap-[1.5rem] lg:gap-[3.5rem] flex-col max-sm:mb-[20px]'>
                    {!title && <div className='ms-[10px] esi-download-title'>
                        {t("text_viewMore_app")} <br />
                        {t("text_moreDetails")}
                    </div>}
                    <div className='flex flex-col gap-3 w-fit items-start'>
                        <img alt='ESI-Logo' role='button' onClick={() => { navigate("/") }} src={BASE_URL + "/logo.svg"} className='esi-download-logo' />
                        <div className={`ms-[6px] esi-download-description ${validLang ? `esi-download-descriptions` : ``}`}>{t("text_logoText")}</div>
                    </div>
                </div>
                {/* <div className='flex gap-[1.5rem] lg:gap-[3.5rem] flex-col max-sm:mb-[20px]'>

                    <div className='flex flex-row flex-wrap gap-[1.5rem] lg:gap-[3.5rem] '>

                        <div className='flex flex-col items-center'>
                            <span className='mb-2 text-center'>
                                Android下载
                            </span>

                            <QRCode
                                size={window.innerWidth < 640 ? 140 : 200}
                                type="svg"
                                errorLevel='H'
                                value={APP_ANDROID_APK_URL}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto'
                                }}
                            />
                        </div>

                        <div className='flex flex-col items-center'>
                            <span className='mb-2 text-center'>
                                App Store下载
                            </span>

                            <QRCode
                                size={window.innerWidth < 640 ? 140 : 200}
                                type="svg"
                                errorLevel='H'
                                value={APP_IOS_URL}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto'
                                }}
                            />
                        </div>

                    </div>

                </div> */}
                 {/* <div className='flex gap-[1.5rem] lg:gap-[3.5rem] flex-col max-sm:mb-[20px]'>
                    <div className='flex flex-row sm:flex-row gap-3'>
                         <span>Android下载</span>
                        <QRCode
                            size={window.innerWidth < 640 ? 140 : 200}
                            type={"svg"}
                            errorLevel='H'
                            value={APP_ANDROID_APK_URL}
                            style={{ marginBottom: 16, maxWidth: '100%', height: 'auto' }}
                        />
                        <span>App Store下载</span>
                        <QRCode
                            size={window.innerWidth < 640 ? 140 : 200}
                            type={"svg"}
                            errorLevel='H'
                            value={APP_IOS_URL}
                            style={{ marginBottom: 16, maxWidth: '100%', height: 'auto' }}
                        />
                    </div>
                </div> */}
                <div className='esi-download-button-container flex flex-col sm:flex-row gap-3'>
                    <div className='flex flex-col items-center-'>

                        <QRCode
                            size={200}
                            type="svg"
                            errorLevel='H'
                            value={APP_ANDROID_APK_URL}
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                margin: "auto"
                            }}
                        />
                        <Button onClick={downloadApk} size='large' className='esi-btn-android mt-2' icon={<AndroidIcon className='esi-android-icon' color='white' />}>{t("text_android_down")}</Button>
                    </div>
                    <div className='flex flex-col items-center-'>

                        <QRCode
                            size={200}
                            type="svg"
                            errorLevel='H'
                            value={APP_IOS_URL}
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                margin: "auto"
                            }}
                        />
                        <Button onClick={downloadIos }size='large' className='esi-btn-apple mt-2' icon={<AppleIcon className='esi-apple-icon' color='white' />} >{t("text_appstore_down")}</Button>
                    </div>
                    
                    
                    <Button onClick={openQrDownload} size='large' className='esi-btn-window mt-auto' icon={<WindowIcon className='esi-window-icon' color='black' />}>{t("text_scanQr")}</Button>
                </div>
            </div>
            <AppQRDownloadModal ref={appQRDownloadModalRef} />
            <AppStoreDownloadModal ref={appStoreDownloadModalRef} />
            <AndroidDownloadModal ref={androidDownloadModalRef} />
        </div>
    )
}